




































import LoadingSpinner from "./LoadingSpinner.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import jsyaml from "js-yaml";

@Component({
  components: { LoadingSpinner }
})
export default class TemplateListing extends Vue {
  loading = false;
  @Prop({ required: true })
  // @ts-ignore
  manifestData: { [index: string]: any };
  @Prop({ required: false, default: false })
  // @ts-ignore
  custom: boolean;
  customURL: string = "";

  doCustom() {
    this.$router.push({ name: "Template", query: { url: this.customURL } });
  }
}
